export default __webpack_public_path__ + "static/media/PurchaseBadges.8d54061b.svg";